import { render, staticRenderFns } from "./VDelete.vue?vue&type=template&id=7528c713&"
import script from "./VDelete.vue?vue&type=script&lang=js&"
export * from "./VDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports